import * as React from 'react';
import {
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  useTranslate,
} from 'react-admin';
import moment from 'moment';
import { ScopedIteratorFields } from './event-utils/ScopedIteratorFields';
import { EditableImage } from './EditableImageField';

const HERO_EVENT_FILTER = {
  status: 'notPast',
  isActive: 'true',
  hasSessions: 'false',
};

const HERO_GROUP_EVENT_FILTER = {
  status: 'notPast',
  isActive: 'true',
};

/** Web hero kart olcusu (275×344) — crop bu oranda. */
const HERO_CARD_WIDTH = 275;
const HERO_CARD_HEIGHT = 344;
const HERO_CARD_ASPECT = HERO_CARD_WIDTH / HERO_CARD_HEIGHT;

const HeroSpecialEvents = () => {
  const translate = useTranslate();

  return (
    <React.Fragment>
      <h3>Home Special Event Hero</h3>
      <span style={{ fontSize: 12, display: 'block', marginBottom: 16 }}>
        Ana sayfa üst carousel. &quot;Add&quot; ile istediğiniz kadar etkinlik ekleyin.
      </span>
      <ArrayInput source="specialEvents" label="Etkinlikler" defaultValue={[]}>
        <SimpleFormIterator inline={false}>
          <ScopedIteratorFields>
            {({ scopedFormData, getSource }) => {
              const featuredSource = getSource('featuredImage');
              const featuredRecord = scopedFormData?.featuredImage
                ? { [featuredSource]: scopedFormData.featuredImage }
                : undefined;

              return (
                <React.Fragment>
                  <ReferenceInput
                    source={getSource('eventId')}
                    reference="events-v2"
                    filter={HERO_EVENT_FILTER}
                    label="Etkinlik"
                    sort={{ field: 'startdate', order: 'ASC' }}
                    perPage={50}
                  >
                    <AutocompleteInput
                      optionText={(r) =>
                        `${r.name} - ${moment(r.startdate).format('DD-MM-YYYY')}`
                      }
                      matchSuggestion={() => true}
                      filterToQuery={(searchText) => ({ q: searchText })}
                      fullWidth
                    />
                  </ReferenceInput>
                  {!scopedFormData?.eventId ? (
                    <ReferenceInput
                      source={getSource('groupid')}
                      reference="groupEvents"
                      filter={HERO_GROUP_EVENT_FILTER}
                      label="Grup etkinliği"
                      perPage={50}
                    >
                      <SelectInput optionText="name" fullWidth />
                    </ReferenceInput>
                  ) : null}
                  <EditableImage
                    source={featuredSource}
                    record={featuredRecord}
                    aspect={HERO_CARD_ASPECT}
                    width={HERO_CARD_WIDTH}
                    height={HERO_CARD_HEIGHT}
                    label={translate('heros.featured_image', {
                      _: "Özel görsel (opsiyonel — yoksa etkinlik banner'ı)",
                    })}
                    hint={translate('heros.featured_crop_hint', {
                      _: `Hero kart ölçüsü ${HERO_CARD_WIDTH}×${HERO_CARD_HEIGHT}. Kaydetmeden önce kırpın.`,
                    })}
                    cropTitle={translate('heros.featured_crop_title', {
                      _: `Görseli Kırp (${HERO_CARD_WIDTH}×${HERO_CARD_HEIGHT})`,
                    })}
                    cropDesc={translate('heros.featured_crop_desc', {
                      _: 'Kırpma alanı hero kart oranında kilitli. Alanı sürükleyip boyutunu ayarlayabilirsiniz.',
                    })}
                  />
                </React.Fragment>
              );
            }}
          </ScopedIteratorFields>
        </SimpleFormIterator>
      </ArrayInput>
    </React.Fragment>
  );
};

export default HeroSpecialEvents;
